'use client';

import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ExternalLink } from "lucide-react";
import Link from 'next/link';

const Objections = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const objections = [
        {
            question: "Is it too good to be true at $19.99/mo?",
            answer: "We're profitable at this price because we built for developers and founders. No sales team, no fancy offices — just great software at honest pricing.",
            tag: "💰 Pricing"
        },
        {
            question: "What if I need more than 20 articles?",
            answer: "Upgrade anytime to 40 or 100 articles per month. No lock-in, no penalties. Switch plans in one click.",
            tag: "📈 Scaling"
        },
        {
            question: "Does it really index in Bing for AI search?",
            answer: "Yes. Every article published through Seozast is automatically indexed in Bing, making it visible to ChatGPT, Copilot, and Perplexity.",
            //   link: "/case-studies/ai-search-indexing",
            //   linkText: "See proof & case study",
            tag: "🤖 AI Search"
        }
    ];

    return (
        <section className="py-12 bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Header */}
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">
                        Common Questions Before You Switch
                    </h2>
                    <p className="text-gray-600">
                        Real answers to real concerns
                    </p>
                </div>

                {/* Objections List */}
                <div className="space-y-3">
                    {objections.map((objection, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:border-emerald-300 transition-colors"
                        >
                            <button
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                            >
                                <div className="flex items-center gap-3 flex-1">
                                    <HelpCircle className="w-5 h-5 text-emerald-600 flex-shrink-0" />
                                    <div className="flex-1">
                                        <span className="text-xs font-semibold text-emerald-600 mb-1 block">
                                            {objection.tag}
                                        </span>
                                        <h3 className="text-base font-semibold text-gray-900">
                                            {objection.question}
                                        </h3>
                                    </div>
                                </div>
                                <ChevronDown
                                    className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'transform rotate-180' : ''
                                        }`}
                                />
                            </button>

                            {openIndex === index && (
                                <div className="px-5 pb-4 pt-0">
                                    <div className="pl-8 border-l-2 border-emerald-200">
                                        <p className="text-sm text-gray-700 mb-2">
                                            {objection.answer}
                                        </p>
                                        {/* {objection.link && (
                      <Link
                        href={objection.link}
                        className="inline-flex items-center gap-1 text-sm font-semibold text-emerald-600 hover:text-emerald-700"
                      >
                        {objection.linkText}
                        <ExternalLink className="w-3 h-3" />
                      </Link>
                    )} */}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Bottom CTA */}
                <div className="mt-6 text-center">
                    <p className="text-sm text-gray-600">
                        Still have questions?{' '}
                        <Link
                            href="mailto:seozast@hotmail.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-semibold text-emerald-600 hover:text-emerald-700"
                        >
                            Talk to us
                        </Link>
                    </p>
                </div>

            </div>
        </section>
    );
};

export default Objections;